module.exports = __webpack_public_path__ + "assets/img/noticeIcon.aa0f0293.png";